var _defs, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg24H(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    id: "svg7767",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs7771"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 46.5,
    r: 44.5,
    stroke: "#42C0EF",
    strokeWidth: 3,
    id: "circle7765"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8813",
    transform: "translate(-1.7592848)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8402",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#42c0ef",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    d: "m 67.48411,19.604873 0.705882,6.569334 -6.56764,0.474628 M 28.708994,26.174208 a 27.917282,27.917282 0 0 1 39.480998,-1e-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8404",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#42c0ef",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    d: "m 61.717174,75.554086 -6.042151,-2.673355 2.87278,-5.925057 M 75.415521,38.689182 A 27.917282,27.917282 0 0 1 55.675023,72.880731"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8406",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#42c0ef",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    d: "m 16.1472,42.585163 5.336269,-3.895979 3.69486,5.450429 M 41.22397,72.880731 A 27.917282,27.917282 0 0 1 21.483469,38.689184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 46.553829,52.569 v 2.240091 H 35.679 c -0.01455,-0.48598 -0.03834,-1.653494 0.129,-2.102091 2.364091,-2.391417 5.264963,-4.689037 7.288799,-7.453038 0.611139,-0.859812 0.916709,-1.671026 0.916709,-2.433642 0,-0.8 -0.280105,-1.472897 -0.840316,-2.01869 -0.552935,-0.553271 -1.276844,-0.829906 -2.171725,-0.829906 -0.94581,0 -1.702458,0.291589 -2.269943,0.874766 -0.567485,0.583177 -1.483921,1.761786 -1.483921,1.761786 l -1.70805,-0.96032 c 0,0 0.969319,-1.317354 1.871476,-2.12483 0.902157,-0.814953 2.113521,-1.222429 3.634092,-1.222429 1.535121,0 2.750123,0.437383 3.645004,1.312148 0.894881,0.874766 1.342322,1.958877 1.342322,3.252334 0,0.657943 -0.130958,1.304672 -0.392874,1.940185 -0.261917,0.635513 -0.698444,1.304671 -1.309582,2.007474 -2.167674,1.850775 -3.643812,3.875416 -5.622745,5.756162 z",
    id: "path8728",
    style: {
      fontSize: 12,
      fontFamily: "Arial",
      InkscapeFontSpecification: "'Arial, Normal'",
      whiteSpace: "pre",
      inlineSize: 26.8096,
      fill: "#42c0ef",
      fillOpacity: 1,
      stroke: "#42c0ef",
      strokeWidth: 0.999999,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 52.647,48.622 h 4.509788 V 45.246 H 59.521 v 3.376 h 1.760971 v 2.250648 H 59.521 v 3.936443 H 57.156788 V 50.872648 H 50.016 l -4.41e-4,-1.850466 6.500882,-10.654194 h 2.104302 z",
    id: "path8730",
    style: {
      fontSize: 12,
      fontFamily: "Arial",
      InkscapeFontSpecification: "'Arial, Normal'",
      whiteSpace: "pre",
      inlineSize: 26.8096,
      fill: "#42c0ef",
      fillOpacity: 1,
      stroke: "#42c0ef",
      strokeWidth: 0.999999,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 63.510156,41.290561 v -7.28912 h 0.8709 v 2.615333 q 0.609631,-0.72593 1.53859,-0.72593 0.570923,0 0.991858,0.23369 0.420935,0.228717 0.599953,0.63643 0.183857,0.407715 0.183857,1.183364 v 3.346233 h -0.8709 v -3.346233 q 0,-0.671235 -0.285461,-0.974535 -0.280623,-0.30827 -0.798325,-0.30827 -0.387067,0 -0.730589,0.208829 -0.338683,0.203856 -0.483833,0.556876 -0.14515,0.353021 -0.14515,0.974535 v 2.888798 z",
    id: "path8732",
    style: {
      fontSize: 12,
      fontFamily: "Arial",
      InkscapeFontSpecification: "'Arial, Normal'",
      whiteSpace: "pre",
      inlineSize: 26.8096,
      fill: "#42c0ef",
      fillOpacity: 1,
      stroke: "#42c0ef",
      strokeWidth: 0.443347,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg24H);
export default __webpack_public_path__ + "static/media/24h.23916b9976331f36e49d2aeeb309e4b6.svg";
export { ForwardRef as ReactComponent };